import { Component, OnInit } from '@angular/core';
import {PublicService} from '../public.service';
import { FormControl, Validators } from '@angular/forms';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-done',
  templateUrl: './done.component.html',
  styleUrls: ['./done.component.scss']
})
export class DoneComponent implements OnInit {

  constructor(public publicservice : PublicService, public router: Router) {
    // if ( publicservice.logedIn == "false" || this.publicservice.logedIn == null ) {
    //   this.router.navigate(['login']);
    // }
  }

  ngOnInit(): void {
  }

  backhome() {
    this.router.navigate(['home']);
  }

}
